export default __webpack_public_path__ + "static/media/video-icon.f96847d1.svg";